import React from 'react';
import PropTypes from 'prop-types';

const iconShipping = ({ className }) => (
    <svg
      width="38px"
      height="46px"
      viewBox="0 0 38 46"
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-889.000000, -2561.000000)"
          fill="#27919C"
          fillRule="nonzero"
        >
          <g id="KSP/FlatRate" transform="translate(890.000000, 2566.000000)">
            <path
              d="M19.3371833,9.39276445 L30.0825276,15.123915 C31.3022147,15.7734144 32.06325,17.0427999 32.06325,18.4239 L32.06325,30.5904 C32.06325,31.9560874 31.3180018,33.2146231 30.1194423,33.8707218 L19.3059768,39.7933803 C18.1771335,40.4136003 16.8079088,40.4077137 15.6835035,39.7789908 L4.99850851,33.808714 C3.82438777,33.1518933 3.09185293,31.9139984 3.08328267,30.5704734 L2.99297956,18.7506352 C2.98258835,17.383594 3.72028868,16.11868 4.91714761,15.4516143 L15.7590794,9.42465219 C16.8691851,8.80745056 18.2161105,8.79571776 19.3371833,9.39276445 Z M5.25042243,19.775 L5.33322711,30.5547231 C5.33663799,31.0893786 5.628867,31.5832101 6.09649649,31.8448092 L16.4814224,37.647 L16.4819606,25.7650406 C16.3359401,25.7182995 16.1921433,25.6623491 16.0514373,25.5971935 L15.8432722,25.4928095 L5.25042243,19.775 Z M29.8124224,20.003 L19.3659851,25.5118749 C19.1610677,25.6197053 18.9487003,25.7072923 18.7316976,25.7746488 L18.7314224,37.542 L29.0388259,31.8972051 C29.5161777,31.6358998 29.81325,31.1342198 29.81325,30.5904 L29.8124224,20.003 Z M16.8523524,11.3911857 L6.01144351,17.4175784 C5.94925413,17.4522395 5.89017097,17.4909377 5.83444746,17.5332346 L16.9129204,23.5133269 C17.3504072,23.7500141 17.8771637,23.7528122 18.3173827,23.5211635 L18.3173827,23.5211635 L29.5602245,17.59323 C29.4264011,17.3940065 29.2440643,17.2265542 29.0243167,17.1095356 L18.2789307,11.3783628 C17.832086,11.140388 17.2950256,11.1450662 16.8523524,11.3911857 Z M0.795577568,2.41398732 L8.03157757,9.65148732 L6.44042243,11.2423127 L-0.795577568,4.00481268 L0.795577568,2.41398732 Z M34.6930873,1.86707243 L36.2839127,3.45822757 L29.0464127,10.6942276 L27.4555873,9.10307243 L34.6930873,1.86707243 Z M19.14225,-4.5 L19.14225,5.7345 L16.89225,5.7345 L16.89225,-4.5 L19.14225,-4.5 Z"
              id="FlatRate"
            />
          </g>
        </g>
      </g>
    </svg>
  );

iconShipping.propTypes = {
  className: PropTypes.string
}

export default iconShipping;
